import { Col, Row } from "antd";
import React, { FC, useState } from "react";

import Address from "@/components/Account/Address";
import ChangePassword from "@/components/Account/ChangePassword";
import PersonalInformation from "@/components/Account/PersonalInformation";
import { IMAGES } from "@/constant";
import styles from "@/pages/Setting/Setting.module.css";
import { useAuthStore } from "@/stores/authStore";

const Account: FC = () => {
  const name = useAuthStore((store) => store?.customer?.name);
  const [activeIndex, setActiveIndex] = useState(0);

  const accountTabs = [
    { label: "Personal Information", content: <PersonalInformation /> },
    { label: "Address", content: <Address /> },
    { label: "Change Password", content: <ChangePassword /> },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.profileContainer}>
          <Row gutter={16} className={styles.profileContainerRow}>
            <Col span={8}>
              <div className={styles.profileCard}>
                <div className={styles.avatar}>
                  <img src={IMAGES.PROFILE_AVATAR} />
                </div>
                <h2 className={styles.name}>{name}</h2>
                <hr className={styles.separator} />
                <div className={styles.tabsContainer}>
                  {accountTabs.map((tab, index) => (
                    <button
                      key={index}
                      className={`${styles.tabButton} ${activeIndex === index ? styles.active : ""}`}
                      onClick={() => setActiveIndex(index)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>
            </Col>

            <Col span={16} className={styles.tabContent}>
              {accountTabs[activeIndex].content}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Account;
